import { css } from "lit";

export const styles = css`
  .form-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 16px;
    max-height: 80vh;
    overflow-y: auto;
  }

  .form-row {
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .form-row > * {
    flex: 1;
  }

  .stream-test-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-border-radius-03);
    border: 1px solid var(--sds-color-border-default-default);
    margin-top: 8px;
  }

  .stream-test-header {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-02) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-default);
  }

  .end-event-section {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 20px;
    background: var(--sds-color-background-danger-subtle);
    border-radius: var(--sds-border-radius-03);
    border: 1px solid var(--sds-color-border-danger-default);
    margin-top: 8px;
  }

  .warning-banner {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--sds-color-text-danger-default);
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-02) var(--sds-typography-family-body);
  }

  .warning-banner ph-warning {
    flex-shrink: 0;
  }

  .obs-info-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
    background: var(--sds-color-background-default-tertiary);
    border-radius: var(--sds-border-radius-02);
  }

  .obs-info-header {
    font: var(--sds-typography-weight-semibold) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .stream-info-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .stream-info-label {
    font: var(--sds-typography-weight-medium) var(--sds-typography-scale-01) var(--sds-typography-family-body);
    color: var(--sds-color-text-default-secondary);
    min-width: 32px;
  }

  .stream-info-value {
    flex: 1;
    font: var(--sds-typography-weight-regular) var(--sds-typography-scale-01) var(--sds-typography-family-mono);
    color: var(--sds-color-text-default-default);
    background: var(--sds-color-background-default-secondary);
    padding: 4px 8px;
    border-radius: var(--sds-border-radius-01);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .streaming-buttons {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
  }

  .streaming-buttons wow-button {
    flex: 1;
    min-width: 140px;
  }

  .background-images-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .background-images-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  @media (max-width: 768px) {
    .form-row {
      flex-direction: column;
    }

    .stream-test-section {
      padding: 16px;
    }

    .end-event-section {
      padding: 16px;
    }

    .streaming-buttons {
      flex-direction: column;
    }

    .streaming-buttons wow-button {
      width: 100%;
    }

    .background-images-grid {
      grid-template-columns: 1fr;
    }
  }
`;
